/**
 * EmptyState v2 — состояние диалога до первого сообщения.
 *
 * Hero welcome: круглый avatar 64px с градиентом + halo + pulse, заголовок,
 * интро, ниже — подсказки-карточки с иконкой слева.
 *
 * Props:
 *   heroIcon    — Lucide-компонент для большой иконки (default Sparkles)
 *   heading     — string (короткий welcome heading, опц. — если не передан, не рендерим)
 *   intro       — string | ReactNode (1-2 предложения)
 *   suggestions — Array<string | { text, icon }> — текст подсказки или объект
 *                 с иконкой Lucide (default иконка Sparkle)
 *   onPick      — (text) => void
 *   disabled    — boolean
 *   suggestLabel — string (default "Подсказки для старта")
 */

import { Sparkles } from 'lucide-react'

import SuggestionChips from './SuggestionChips'

export default function EmptyState({
    heroIcon: HeroIcon = Sparkles,
    heading = null,
    intro = null,
    suggestions = [],
    onPick,
    disabled = false,
    suggestLabel = 'Подсказки для старта',
}) {
    return (
        <div className="conversation__empty">
            {HeroIcon ? (
                <span className="conversation__empty-hero" aria-hidden="true">
                    <HeroIcon size={28} />
                </span>
            ) : null}

            {heading ? (
                <h3 className="conversation__empty-heading">{heading}</h3>
            ) : null}

            {intro ? (
                typeof intro === 'string' ? (
                    <p className="conversation__empty-intro">{intro}</p>
                ) : (
                    intro
                )
            ) : null}

            {suggestions.length > 0 ? (
                <SuggestionChips
                    items={suggestions}
                    onPick={onPick}
                    disabled={disabled}
                    label={suggestLabel}
                    variant="stacked"
                />
            ) : null}
        </div>
    )
}
